import { createSelector } from 'reselect';
import getRolesFromPermissions from '../permissions/getRolesFromPermissions';
import { RegionalSettingNames } from '../api/user';
export const getUserProfile = (state) => state.profiling ? state.profiling.userProfile : null;
export const getUserCompany = (state) => state.profiling ? state.profiling.company : null;
export const getUserProfileLoadedStatus = (state) => state.profiling.userProfileLoaded;
export const getUserApps = (state) => state.profiling.userApps;
export const getTenantsSettings = (state) => { var _a, _b; return (_b = (_a = state.profiling) === null || _a === void 0 ? void 0 : _a.tenantsSettings) !== null && _b !== void 0 ? _b : null; };
export const getLocale = createSelector([getUserProfile], (userProfile) => (userProfile && userProfile.locale) || 'en');
export const getUserTenantId = createSelector([getUserProfile], (userProfile) => (userProfile && userProfile.company && userProfile.company.tenantId) || null);
export const getUserFiscalEntity = createSelector([getUserCompany], (company) => (company && company.billing.fiscalEntity) || null);
export const isBillingEditable = createSelector([getUserCompany], (company) => (company && company.billing.editable) || false);
export const getUserPreferredAppId = createSelector([getUserProfile], (userProfile) => (userProfile && userProfile.settings.preferredAppId) || null);
export const getUserPreferredApp = createSelector([getUserApps, getUserPreferredAppId], (userApps) => (userApps ? userApps.find((app) => app.isPreferred) : null));
export const getRegionalSettingsName = createSelector([getUserProfile], (userProfile) => { var _a, _b; return (_b = (_a = userProfile === null || userProfile === void 0 ? void 0 : userProfile.settings) === null || _a === void 0 ? void 0 : _a.regionalSettingsName) !== null && _b !== void 0 ? _b : null; });
export const getDateFormat = createSelector([getRegionalSettingsName], (regionalSettingsName) => {
    if (!regionalSettingsName) {
        return 'dd/MM/yyyy';
    }
    const dateMap = {
        [RegionalSettingNames.INTERNATIONAL]: 'dd/MM/yyyy',
        [RegionalSettingNames.US]: 'MM/dd/yyyy',
        [RegionalSettingNames.UK]: 'dd/MM/yyyy',
    };
    return dateMap[regionalSettingsName];
});
export const getTimeFormat = createSelector([getUserProfile], (userProfile) => userProfile && userProfile.settings ? userProfile.settings.timeFormat : 'HH:mm:ss');
export const getDateTimeFormat = createSelector([getDateFormat, getTimeFormat], (dateFormat, timeFormat) => `${dateFormat} ${timeFormat}`);
export const getUserPermissions = createSelector([getUserProfile], (user) => (user && user.permissions) || []);
export const getUserRoles = createSelector([getUserPermissions], (userPermissions) => {
    return getRolesFromPermissions(userPermissions);
});
export const getUserRolesForApp = createSelector([getUserPermissions], (userPermissions) => (appId) => {
    return getRolesFromPermissions(userPermissions, appId);
});
export const hasPermission = createSelector([getUserRoles], (roles) => (permissionToCheck) => roles && roles.includes(permissionToCheck));
export const getRetryMutationOnCompanyStatus = (state) => state.profiling.retryMutationOnCompany;
export const getTenantSettings = createSelector([getTenantsSettings, getUserTenantId], (tenantsSettings, tenantId) => {
    var _a;
    if (!tenantId) {
        return null;
    }
    return (_a = tenantsSettings === null || tenantsSettings === void 0 ? void 0 : tenantsSettings.find((tenantSettings) => tenantSettings.id === tenantId)) !== null && _a !== void 0 ? _a : null;
});
//# sourceMappingURL=profiling.selector.js.map